<template>
  <div class="setComponent">
    <!-- 二级标题 -->
    <div class="title">
      <h4>{{$t("wm_lang_html_7fc88a")}}</h4>
      <el-divider></el-divider>
    </div>
    <!-- 表单 -->
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0" class="demo-ruleForm" size="medium">
      <el-form-item>
        <el-button type="primary" @click="toChangePassword">{{$t("wm_lang_html_7fc88a")}}</el-button>
      </el-form-item>
    </el-form>
    <br><br>
    <!-- 二级标题 -->
    <div class="title" v-show="secureLoginVerifyOnOff">
      <h4>{{$t("comm_lang_0099")}}</h4>
      <el-divider></el-divider>
    </div>
    <!-- 表单 -->
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0" class="demo-ruleForm" size="medium" v-show="secureLoginVerifyOnOff">
      <el-form-item v-show="!mobileText">
        <el-button type="primary" @click="toBindMobile">{{$t("custom_lang_0112")}}</el-button>
      </el-form-item>
      <el-form-item v-show="!!mobileText">
        {{$t("custom_lang_0132")}} {{mobileText}}<a href="javascript:;" class="ml15" @click="toUnBindMobile">{{$t("custom_lang_0133")}}</a>
      </el-form-item>
    </el-form>
    <br v-show="secureLoginVerifyOnOff"><br v-show="secureLoginVerifyOnOff">
    <!-- 二级标题 -->
    <div class="title">
      <h4>{{$t("custom_lang_0111")}}</h4>
      <el-divider></el-divider>
    </div>
    <!-- 表单 -->
    <el-form :model="securitySettingForm" ref="ruleForm" :label-width="labelWidth" class="demo-ruleForm" size="medium">
      <el-form-item :label="$i18n.t('comm_lang_0063')" class="bottomNo flex">
        <el-switch v-model="securitySettingForm.remoteLoginRemind" @change="strangeLoginOpen"></el-switch>
        <span class="ml20">{{$t("custom_lang_0020")}}<a href="javascript:;" @click="toTrustLocation">{{$t("custom_lang_0021")}}</a> {{$t("custom_lang_0022")}}<a href="javascript:;" @click="toStrangeLoginLog">{{$t("custom_lang_0023")}}</a></span>
      </el-form-item>
      <el-form-item :label="$i18n.t('custom_lang_0113')" class="bottomNo">
        <el-checkbox :label="$i18n.t('custom_lang_0114')" value="1" name="type" v-model="securitySettingForm.remoteLoginRemindEmail" @change="securitySettingSave" :disabled="!securitySettingForm.remoteLoginRemind"></el-checkbox>
        <el-checkbox :label="$i18n.t('custom_lang_0115')" value="2" name="type" v-model="securitySettingForm.remoteLoginRemindSms" @change="securitySettingSave" :disabled="!securitySettingForm.remoteLoginRemind || !mobile" v-show="secureLoginVerifyOnOff"></el-checkbox>
      </el-form-item>
    </el-form>
    <br><br>
    <!-- 二级标题 -->
    <div class="title" v-show="secureLoginVerifyOnOff">
      <h4>{{$t("custom_lang_0116")}}</h4>
      <el-divider></el-divider>
    </div>
    <!-- 表单 -->
    <el-form :model="securitySettingForm" ref="ruleForm" :label-width="labelWidth" class="demo-ruleForm" size="medium" v-show="secureLoginVerifyOnOff">
      <el-form-item :label="$i18n.t('custom_lang_0117')" class="bottomNo flex">
        <el-switch v-model="securitySettingForm.secureLoginVerify" @change="secureLoginVerifyOpen"></el-switch>
        <span class="ml20">{{$t("custom_lang_0118")}}</span>
      </el-form-item>
      <el-form-item :label="$i18n.t('custom_lang_0119')" class="bottomNo">
        <el-radio-group v-model="securitySettingForm.secureLoginVerifyFreq" @change="securitySettingSave" :disabled="!securitySettingForm.secureLoginVerify">
          <el-radio :label="1">{{$t("custom_lang_0120")}}</el-radio>
          <el-radio :label="2">{{$t("custom_lang_0121")}}</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <br><br>
  </div>
</template>

<script>
import xmail from '@/api/api';
import storeLocal from 'store';
export default {
  name: 'setComponent',
  data () {
    return {
      msgindex: this.$i18n.t('wm_lang_dade72'),
      // 进度条
      customColors: [
        {color: '#e6a23c', percentage: 50},
        {color: '#f56c6c', percentage: 80},
        {color: '#67c23a', percentage: 100}
      ],
      // 表格
      tableData: [{
        detection:this.$i18n.t('wm_lang_320dcb'),
        number: '60',
        name: this.$i18n.t('wm_lang_e75969'),
        unread: '5677',
        size: '20.34M'
      }, {
        detection:this.$i18n.t('wm_lang_8dd066'),
        number: '452454',
        name: this.$i18n.t('wm_lang_93d159'),
        unread: '645',
        size: '9.69M'
      }, {
        detection:this.$i18n.t('wm_lang_21cad5'),
        number: '3445',
        name: this.$i18n.t('wm_lang_5cc232'),
        unread: '43',
        size: '0B'
      }, {
        detection:this.$i18n.t('wm_lang_fec2b4'),
        number: '2456',
        name: this.$i18n.t('wm_lang_22b433'),
        unread: '12',
        size: '2.00G'
      }],
      // 表单
      ruleForm: {
        tex: '',
        select: '',
        date1: '',
        date2: '',
        switch: false,
        type: [],
        radio: '',
        desc: ''
      },
      rules: {
        tex: [
          { required: true, message: this.$i18n.t('wm_lang_47631c'), trigger: 'blur' },
          { min: 3, max: 5, message: this.$i18n.t('wm_lang_0c9e6a')+' 3 '+this.$i18n.t('wm_lang_d716f1')+' 5 '+this.$i18n.t('wm_lang_15d410'), trigger: 'blur' }
        ],
        select: [
          { required: true, message: this.$i18n.t('wm_lang_708c9d'), trigger: 'change' }
        ],
        date1: [
          { type: 'date', required: true, message: this.$i18n.t('wm_lang_aa2fb1'), trigger: 'change' }
        ],
        date2: [
          { type: 'date', required: true, message: this.$i18n.t('wm_lang_fbd05a'), trigger: 'change' }
        ],
        type: [
          { type: 'array', required: true, message: this.$i18n.t('wm_lang_0efb20'), trigger: 'change' }
        ],
        radio: [
          { required: true, message: this.$i18n.t('wm_lang_708c9d'), trigger: 'change' }
        ],
        desc: [
          { required: true, message: this.$i18n.t('wm_lang_ad9c40'), trigger: 'blur' }
        ]
      },
      securitySettingForm: {
        remoteLoginRemind: false,
        remoteLoginRemindEmail: false,
        remoteLoginRemindSms: false,
        secureLoginVerify: false,
        secureLoginVerifyFreq: 0,
        secureLoginVerifyMethod: 1
      },
      mobile: "",
      mobileText: "",
      // 上传头像
      imageUrl: '',
      labelWidth: '100px',
      localConfigSetting: {},
      secureLoginVerifyOnOff: false
    }
  },
  beforeMount() {
    this.localConfigSetting = storeLocal.get('Pwm-configSetting');
    this.secureLoginVerifyOnOff = this.localConfigSetting.displaySetting.secureLoginVerifyOnOff==1;
    if(this.localConfigSetting.displaySetting.language == 3){
      this.labelWidth = "200px";
    }
  },
  mounted() {
    this.getSecurity();
  },
  methods: {
    toChangePassword() {
      this.$router.push({name: 'changePassword'});
    },
    toBindMobile() {
      this.$router.push({name: 'bindMobile'});
    },
    toUnBindMobile() {
      this.$router.push({name: 'unBindMobile', params: {mobile: this.mobile,mobileText: this.mobileText}});
    },
    toStrangeLoginLog() {
      this.$router.push({name: 'strangeLoginLog'});
    },
    toTrustLocation() {
      this.$router.push({name: 'trustLocation'});
    },
    getSecurity() {
      let self = this;
      (function (api, enums, pms) {
        api.Account.queryRemoteEnable({}, function (res) {
          // console.log(res.data);
          if(res.data.code === 0) {
            self.securitySettingForm.remoteLoginRemind = res.data.data.remoteLoginRemind;
            self.securitySettingForm.remoteLoginRemindEmail = res.data.data.remoteLoginRemindEmail;
            self.securitySettingForm.remoteLoginRemindSms = res.data.data.remoteLoginRemindSms;
            self.securitySettingForm.secureLoginVerify = res.data.data.secureLoginVerify;
            self.securitySettingForm.secureLoginVerifyFreq = res.data.data.secureLoginVerifyFreq;
            if(res.data.data.mobileBindInfo && res.data.data.mobileBindInfo.bindId){
              let tel = res.data.data.mobileBindInfo.bindId;
              self.mobile = res.data.data.mobileBindInfo.bindId;
              self.mobileText = tel.replace(tel.substring(3,7), "****");
            }
          }
        })
      })(xmail.api, xmail.enums, xmail.pms);
    },
    strangeLoginOpen() {
      if(this.securitySettingForm.remoteLoginRemind){
        this.securitySettingForm.remoteLoginRemindEmail = true;
      } else {
        this.securitySettingForm.remoteLoginRemindEmail = false;
        this.securitySettingForm.remoteLoginRemindSms = false;
      }
      this.securitySettingSave();
    },
    secureLoginVerifyOpen() {
      if(this.securitySettingForm.secureLoginVerify){
        this.securitySettingForm.secureLoginVerifyFreq = 1;
      } else {
        this.securitySettingForm.secureLoginVerifyFreq = 0;
      }
      this.securitySettingSave();
    },
    securitySettingSave() {
      let self = this;
      (function (api, enums, pms) {
        let pm = pms.Account.saveRemoteEnableParamBuilder();
        pm.remoteLoginRemind = self.securitySettingForm.remoteLoginRemind;
        pm.remoteLoginRemindEmail = self.securitySettingForm.remoteLoginRemindEmail;
        pm.remoteLoginRemindSms = self.securitySettingForm.remoteLoginRemindSms;
        pm.secureLoginVerify = self.securitySettingForm.secureLoginVerify;
        pm.secureLoginVerifyFreq = self.securitySettingForm.secureLoginVerifyFreq;
        pm.secureLoginVerifyMethod = self.securitySettingForm.secureLoginVerifyMethod;
        api.Account.saveRemoteEnable(pm, function (res) {
          // console.log(res.data);
          self.$message({
            type: 'success',
            message: self.$i18n.t('wm_lang_3b1083')
          });
        })
      })(xmail.api, xmail.enums, xmail.pms);
    },
    // 账号安全检测进度
    format(percentage) {
      return percentage === 50 ? this.$i18n.t('wm_lang_19ac67') : `${percentage}%`;
    },
    // 表单
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!');
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .setComponent{padding:10px;}
 .setComponent .title .el-divider--horizontal{margin:10px 0;}
 .setComponent .bottomNo{margin-bottom:0px;}
 .setComponent .flex >>> .el-form-item__content{display: flex;}
 .setComponent .flex .el-switch{margin-top:9px;}
</style>



// WEBPACK FOOTER //
// src/components/views/setBox/accountSecurity.vue